// extracted by mini-css-extract-plugin
export default {"container":"PostAction_container__rrlx9"};